import qs from 'query-string';

interface ReportInfo {
  [key: string]: string | object;
}

/**
 * 绑定自定义上报指令
 * 客户端上报相关文档  https://iwiki.woa.com/p/886118192
 * @param app vue实例
 */
export const bindReportDirective = (app: any) => {
  app.directive('report', {
    mounted(el: any, binding: any) {
      bindHandler(el, binding);
    },
    updated(el: any, binding: any) {
      bindHandler(el, binding);
    },
  });
};

const stringifyParams = (params: any) => {
  if (typeof params === 'object') return JSON.stringify(params);
  return params;
};
const bindHandler = (el: any, binding: any) => {
  if (import.meta.env.EVO) {
    bindHandlerForEvo(el, binding);
  } else {
    bindHandlerForWeb(el, binding);
  }
};
const bindHandlerForEvo = (el: any, binding: any) => {
  setTimeout(() => {
    const attrMap: ReportInfo = binding.value.type === 'page'
      ? {
        'page-id': binding.value.id,
        'page-params': stringifyParams(binding.value.params || ''),
      }
      : {
        'element-id': binding.value.id,
        'element-params': stringifyParams(binding.value.params || ''),
        'element-exposure-policy': binding.value.exposurePolicy || '3',
        'force-last-click-element': binding.value.forceLastClick || 'true',
        'element-end-exposure-policy': binding.value.endExposurePolicy || '1',
        'element-interact-policy': binding.value.interactPolicy || '2',
      };
    // eslint-disable-next-line no-restricted-syntax
    for (const key in attrMap) {
      if (Object.prototype.hasOwnProperty.call(attrMap, key)) {
        el.setAttribute(key, attrMap[key]);
      }
    }
  });
};

const stringifyWebParams = (params: any) => {
  if (typeof params === 'object') return qs.stringify(params);
  return params;
};

const bindHandlerForWeb = (el: any, binding: any) => {
  setTimeout(() => {
    const attrMap: ReportInfo = binding.value.type === 'page'
      ? {
        'dt-pgid': binding.value.id,
        'dt-params': stringifyWebParams(binding.value.params || ''),
      }
      : {
        'dt-eid': binding.value.id,
        'dt-params': stringifyWebParams(binding.value.params || ''),
      };
    // eslint-disable-next-line no-restricted-syntax
    for (const key in attrMap) {
      if (Object.prototype.hasOwnProperty.call(attrMap, key)) {
        el.setAttribute(key, attrMap[key]);
      }
    }
  });
};

